<template>
    <v-layout row wrap>
        <v-flex xs12>
            <v-btn text @click="chips=!chips">View</v-btn>
            <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 v-if="chips" :key="key" >
            <!--<v-btn icon to="/groupcontact">-->
                <!--<v-icon>fas fa-external-link-alt</v-icon>-->
            <!--</v-btn>-->
            <v-chip v-for="(d,i) in group.contacts"
                    min-width="200"
                    :key="d.uuid"
                    class="ma-2"
                    close
                    :color="$store.state.color1"
                    text-color="white"
                    @click:close="removeFromGroup(d,i)"
                    @click="$store.dispatch('getActiveContact',d.uuid)">
                {{d.name}}
            </v-chip>
        </v-flex>
        <v-list v-else>
            <v-list-item v-for="(c,i) in group.contacts" :key="i" @click="openContact(c)" >
                <v-list-item-content>
                    <v-list-item-title>
                        {{c.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{c.cell}} | {{c.email}}
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action >

                </v-list-item-action>
            </v-list-item>
        </v-list>
        <v-flex xs12 class="text-center">
            <span class="subtitle-2 font-weight-light">groupcontacts</span>
        </v-flex>
        <VDialog fullscreen v-model="$store.state.activecontact" v-if="$store.state.activecontact">
            <ContactEditor :contact="$store.state.activecontact" />
        </VDialog>
    </v-layout>
</template>

<script>
  import ContactEditor from "../contacts/ContactEditor";
  export default {
    components: {ContactEditor},
    props:['group'],
    name: "GroupContacts",
    data() {
      return {
        key:'0000',
        loading:false,
        view:'chips',
        chips:true
      }
    },
    mounted() {
    },
    methods: {
      async removeFromGroup(d,i){
        //contacts.splice(i,1)
        this.loading=true;
        let data = {
          groupkey:this.group.sortkey,
          contactuuid:i
        }
        await this.$store.dispatch('removeFromGroup',data).then(data=>{
          console.log(data)
        })
        delete this.group.contacts[i]
        this.key = new Date().getTime()//reload key
        this.loading=false;
      },
      openContact: async function (ct) { //triggers the contact dialog panel
        this.$store.dispatch('getActiveContact',ct.uuid)
      },
    }
  }
</script>

<style scoped>

</style>